module.exports = __webpack_public_path__ + "img/tuyau_4.d5619dfc.svg";